import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';

export class Online_Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCateg: [], // Valores únicos para el select
      results: [], // Datos originales
      filteredResults: [], // Datos filtrados
      selectedGroup: '', // Grupo seleccionado para filtrar
      page: 1,
      sort: { key: null, dir: 'asc' },
    };
  }

  handleSort = (key) => {
    this.setState((prev) => ({
      sort: nextSort(prev.sort, key),
      page: 1,
    }));
  }

  componentWillMount() {
    this.getDataUser();
  }

  getDataUser() {
    var user = AuthService.getCurrentUser();
    ApiService.getOnlineUsers(user.token).then(
      (res) => {
        if (res && res.status === 'success') {
          const items = res.data.map((row) => ({
            Grupo: row.hourly_interval,  // Agrupar por 'hourly_interval'
            ID: row.id_user,
            'Nombres': row.fullname,
            Navegador: row.browser,
            Celular: row.phonenumber,
            'Último registro': row.last_seen,
          }));

          // Extraemos los valores únicos de 'Grupo' (hourly_interval)
          const dataCateg = [...new Set(items.map(item => item.Grupo))];

          this.setState({ results: items, filteredResults: items, dataCateg });
        }
      },
      error => {
        const resMessage = (error.response && error.response.data && error.response.data.message) ||
          error.message || error.toString();
      }
    );
  }

  // Maneja el cambio en el select para filtrar por el grupo
  handleGroupChange = (event) => {
    const selectedGroup = event.target.value;
    this.setState({ selectedGroup }, () => {
      this.filterDataByGroup(selectedGroup);
    });
  };

  filterDataByGroup(group) {
    // Filtramos los resultados según el grupo seleccionado
    const filteredResults = group
        ? this.state.results.filter(item => item.Grupo === group)
        : this.state.results; // Si no hay grupo seleccionado, mostramos todos los resultados

    // Actualizamos el estado
    this.setState({ filteredResults, page: 1 });
}

  renderPagination(total, page, pageSize, onPageChange) {
    const totalPages = Math.ceil(total / pageSize);
    if (totalPages <= 1) return null;
    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '10px 16px', borderTop: '1px solid #f0f0f0',
        background: '#fafafa', fontSize: 13, color: '#666',
      }}>
        <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
            style={{
              border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
              background: page === 1 ? '#f4f4f4' : '#fff',
              color: page === 1 ? '#ccc' : '#333',
              cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
            }}
          >
            <i className='fa fa-chevron-left' />
          </button>
          <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
          <button
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
            style={{
              border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
              background: page === totalPages ? '#f4f4f4' : '#fff',
              color: page === totalPages ? '#ccc' : '#333',
              cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
            }}
          >
            <i className='fa fa-chevron-right' />
          </button>
        </div>
      </div>
    );
  }

  renderResults() {
    const { filteredResults, page, sort } = this.state;
    if (filteredResults.length === 0) {
      return 'No hay datos.';
    }

    const PAGE_SIZE = 50;
    const sorted = sortRows(filteredResults, sort);
    const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
    const currentPage = Math.min(page, totalPages);
    const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    const headers = [
      { label: 'Grupo', key: 'Grupo' },
      { label: 'Nombres', key: 'Nombres' },
      { label: 'Navegador', key: 'Navegador' },
      { label: 'Celular', key: 'Celular' },
      { label: 'Último registro', key: 'Último registro' },
    ];

    return (
      <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                {headers.map((h) => (
                  <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} />
                ))}
              </tr>
            </thead>
            <tbody>
              {paginated.map((item, i) => (
                <tr
                  key={i}
                  style={{ borderBottom: '1px solid #f4f4f4' }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = '#f0faf4')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                >
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                    <span style={{ background: '#d4edda', color: '#155724', borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600 }}>
                      {item.Grupo}
                    </span>
                  </td>
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                    <Link to={`${process.env.PUBLIC_URL}/customer-profile/${item.ID}`} style={{ color: '#007bff', fontWeight: 500 }}>
                      {item.Nombres}
                    </Link>
                  </td>
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.Navegador}</td>
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item.Celular}</td>
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>{item['Último registro']}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {this.renderPagination(filteredResults.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        <Breadcrumb title="Seguridad" parent="Usuarios" />
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h5>Usuarios en línea</h5>
            </div>
            <div className="card-body">
              <div style={{ marginBottom: 16, maxWidth: 280 }}>
                <label style={{ fontSize: 13, color: '#666', marginBottom: 4, display: 'block' }}>
                  Seleccione el grupo
                </label>
                <select
                  onChange={this.handleGroupChange}
                  value={this.state.selectedGroup}
                  style={{
                    width: '100%', borderRadius: 8, border: '1px solid #ddd',
                    padding: '8px 12px', fontSize: 14, margin: 0,
                  }}
                >
                  <option value="">Todos</option>
                  {this.state.dataCateg.map((group, index) => (
                    <option key={index} value={group}>
                      {group}
                    </option>
                  ))}
                </select>
              </div>

              <div id="batchDelete">
                {this.renderResults()}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Online_Users;
